import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import UsersListRequests from "./UsersListRequests";
import Menu from "../../../Layout/Menu/Menu";
import Table from "../../../Layout/Table/Table";
import Select from "../../../Layout/Forms/Select";
import NavBar from "../../../../components/NavBarAdmin"
const UsersList = () => {



    const ActionColumn = ({ id }) => {
        return null;
    }

    const ImageColumn = ({ image }) => {
        return image ? <img src={image} className="img-fluid rounded" style={{ height: '50px' }} /> : null
    }

    const columns = ['', "id", "profile", "username", "firstname", "lastname", "phone_country", "phone_number", "email", "email_isValid", "email_isValid_datetime", "create_date", "update_date", "status", "push_notification_token", "allowSmsMarketing", "allowPushNotification", "allowEmailMarketing", "isDoorman", 'Actions'];

    const serializeRowsColums = () => {
        return data.map((item) => {
            // let obj = item;
            // obj["status"] = <StatusColumn status={obj.status} />;
            // obj["Actions"] = <ActionColumn id={obj.id} />;
            return {
                ...item,
                profile: <ImageColumn image={item.image} />,
                Actions: <ActionColumn id={item.id} />,
            };
        })
    }
    const [filter, setFilter] = useState({
        permissions: null
    })
    const [data, setData] = useState([])

    const requestUsers = async () => {
        let info = await UsersListRequests.getUsersList(filter);
        if (info && info.status) {
            setData(info.data)
        }
    }

    useEffect(() => {
        requestUsers()
    }, [])

    useEffect(() => {
        requestUsers()
    }, [filter])

    const handleChangeInputs = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }


    return (
        <div>
            <NavBar>
                <div className="row">
                    <div className="col-xs-12 dashboard-content">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="dashboard-h2"> Users List</h2>
                            </div>

                        </div>
                        <div className="row my-4">
                            <div className="col-4 ">
                                <Select
                                    label="Tipo utilizador"
                                    name="permissions"
                                    value={filter.permissions}
                                    onChangeOption={(e) => handleChangeInputs(e)}
                                    options={[
                                        {
                                            "label": "Todos",
                                            "value": null,
                                        },
                                        {
                                            "label": "User",
                                            "value": "user",
                                        },
                                        {
                                            "label": "Doorman",
                                            "value": "doorman",
                                        },
                                        {
                                            "label": "Owner",
                                            "value": "owner",
                                        },
                                        {
                                            "label": "",
                                            "value": "photo",
                                        },
                                    ]}
                                    style={{ textAlign: "center" }}
                                />
                            </div>


                        </div>
                        <div className="row">
                            <div className="col-12 event-list-table" >
                                <Table
                                    columns={columns}
                                    data={serializeRowsColums(data)}
                                    currentPage={1}
                                    itemsPerPage={100}
                                    totalItems={data.length}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </NavBar>
        </div >
    )
}


export default UsersList;